<template>
  <div class="row">
    <div class="col-lg-12 col-xl-12 mb-5">
      <dashboard-box :title="$t('menu.nap_transfer_requests')">
        <template v-slot:toolbar>

        </template>
        <template v-slot:preview>
          <b-row>
            <b-col sm="12" lg="3" xl="3" class="mb-3">
              <b-input-group size="sm">
                <b-form-input placeholder="Arama yapın"></b-form-input>
                <b-input-group-append>
                  <b-button variant="primary"><i class="fa fa-search"></i> Ara</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col sm="12" lg="9" xl="9">
              <b-form-radio-group
                  id="btn-radios-1"
                  v-model="status_selected"
                  :options="status_options"
                  buttons
                  button-variant="outline-primary"
                  size="sm"
                  class="fa-pull-right"
                  name="radios-btn-default"
              ></b-form-radio-group>
            </b-col>
          </b-row>
          <data-table
              :items="table.items"
              :fields="report.fields"
              :paginate="report.paginate"
              page.sync="3"
              perPage.sync="10"
          ></data-table>
        </template>
      </dashboard-box>
    </div>
  </div>
</template>

<script>
import DataTable from "@/assets/components/dataTable/DataTable";
import DashboardBox from "@/assets/components/DashboardBox";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "NapTransferRequests",
  components: { DataTable, DashboardBox },
  methods: {

  },
  data() {
    return {
      form : {

      },
      status_options : ['Aktif Kampanyalar','Pasif Kampanyalar'],
      status_selected : 'Aktif Kampanyalar',
      report : {
        paginate : {
          next_page_url: "#",
          path: "#",
          per_page: 15,
          prev_page_url: null,
          to: 15,
          total: 48,
          pageNumberProxy:1,
          current_page : 1,
          first_page_url: "http://127.0.0.1:8000/api/samples?page=1",
          from: 1,
          last_page: 20,
          last_page_url: "http://127.0.0.1:8000/api/samples?page=2",
          links: [
            {
              "url": null,
              "label": "&laquo; Öncekiler",
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=1",
              "label": 1,
              "active": true
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": 2,
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": "Sonrakiler &raquo;",
              "active": false
            }
          ],
        },
        fields: [
          {key: 'id', label: '#', sortable: true},
          {key: 'name', label: 'Kampanya Adı', sortable: true},
          {key: 'new', label: 'Yeni Talep', sortable: true},
          {key: 'total', label: 'Toplam Talep', sortable: true},
          {key: 'point', label: 'Puan', sortable: true},
          {key: 'created_at', label: 'Başlangıç', sortable: true},
          {key: 'is_promotion', label: 'P.Kodu?', sortable: true},
          {key: 'remaining_code', label: 'Kalan Kod', sortable: true},
          {key: 'total_code', label: 'Toplam Kod', sortable: false},
          {key: 'transfer_request_action', label: 'İşlem', sortable: false},
        ],
      },
      table : {
        items : [
          {'id' : '3871304', 'name' : '365ist %10 Hediye İndirim Kodu', 'new' : '0','total' : '0', 'point' : '1000', 'created_at' : '04.04.2017', 'is_promotion' : '', 'remaining_code' : '0', 'total_code' : '150'},
          {'id' : '3871305', 'name' : 'Dominos Pizza (Dominos Pizza %40 İndirim)', 'new' : '0','total' : '0', 'point' : '15000', 'created_at' : '15.08.2015', 'is_promotion' : '', 'remaining_code' : '9581', 'total_code' : '10013'},
          {'id' : '3871305', 'name' : 'GoldMaster %50 Hediye İndirim Kodu', 'new' : '22','total' : '22', 'point' : '1000', 'created_at' : '11.01.2017', 'is_promotion' : '', 'remaining_code' : '7905', 'total_code' : '10000'},
          {'id' : '3871305', 'name' : 'Halıstores %10 İndirim', 'new' : '0','total' : '0', 'point' : '1000', 'created_at' : '11.01.2016', 'is_promotion' : '', 'remaining_code' : '674', 'total_code' : '1100'},
          {'id' : '3871305', 'name' : 'Kaave Falı (Kaave Falı\'ndan 25 Fal Kredisi)', 'new' : '0','total' : '0', 'point' : '0', 'created_at' : '13.12.2015', 'is_promotion' : '', 'remaining_code' : '4822', 'total_code' : '5000'},
          {'id' : '3871305', 'name' : 'Napolyon (100 TL Nakit Para Transferi)', 'new' : '25','total' : '25', 'point' : '100000', 'created_at' : '08.05.2010', 'is_promotion' : '', 'remaining_code' : '0', 'total_code' : '0'},
        ],
      },
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t('general.project_2'), route: "alert" },
      { title: this.$t('menu.nap_transfer_requests') }
    ]);
  }
}
</script>

<style scoped>

</style>
